import "./sentry.js"
import "./bootstrap";

import { Livewire, Alpine } from '../../vendor/livewire/livewire/dist/livewire.esm';
import wireui from "./modules/wireui";
import { register } from 'swiper/element/bundle';
import { startCountdown } from './support/startCountdown';

import "./directives";

import './support/textNotification';
import "./support/formatCurrency";
import "./support/pluralize";
import "./support/goToCheckout";
import "./support/requestPhotos";
import "./support/preventBrowserDownload";
import "./support/openNewTab";
import "./support/checkKeyboard";
import "./support/paymentMethodOptions";
import "./support/clearUrlParams";
import "./stores/cart";
import "./stores/customer";
import "./stores/customModal";
import './stores/customerImages';
import './stores/unreadMessages';
import './stores/inactiveRegistrations';
import './stores/requested';
import './stores/packageData';
import './stores/packages';
import './stores/images';
import './stores/disableOrderSave';
import './stores/viewport';

import "./../../vendor/power-components/livewire-powergrid/dist/powergrid";
import "./../../vendor/power-components/livewire-powergrid/dist/tailwind.css";
import "intl-tel-input/build/css/intlTelInput.css";

import './modules';
import './magics';
import './prefetch';

window.startCountdown = startCountdown;

document.addEventListener(
    "DOMContentLoaded",
    function () {
        document.getElementsByTagName("body")[0].removeAttribute("x-cloak");
    },
    false
);

document.addEventListener('toggleDetail', (event) => {
    const params = event.__livewire.params[0]
    if (params.enabled) {
        setTimeout(() => {
            document.getElementById(params.element).classList.add(params.classes)
        }, 300)

        return;
    }

    document.getElementById(params.element).classList.remove(params.classes)
})

Alpine.defaultDataFunction = Alpine.data;
Alpine.data = (dataName, content) => {
    content = wireui(dataName, content)
    return Alpine.defaultDataFunction(dataName, content);
};

Livewire.hook('request', ({ fail }) => {
    fail(({ status, preventDefault }) => {
        if (status === 419) {
            preventDefault();
            window.location.reload();
        }
    });
});

const SEARCH_PARAM_CLEANUP_PAGES = ['/customers', '/players', '/registrations'];

document.addEventListener('livewire:navigated', () => {
    const url = new URL(window.location.href);

    if (url.searchParams.has('search') && SEARCH_PARAM_CLEANUP_PAGES.some(page => url.pathname.endsWith(page))) {
        url.searchParams.delete('search');
        window.history.replaceState({}, '', url.toString());
    }
});

Livewire.start();

register();
